<template>
  <div>
    <transition name="fade">
      <div class="welcome" v-if="welcomeVisible">
        <div class="welcome-shadow"></div>
        <div class="welcome-main">
          <Icon
            class="welcome-main-close"
            name="close"
            @click="hideWelcomePopup"
          />
          <img
            class="welcome-main-img"
            :src="showImage"
            alt="welcome-img"
            object-fit="contain"
            @click="clickPopupHandle"
          />
        </div>
      </div>
    </transition>

    <transition name="fade">
      <AwardRoleSelect
        style="z-index: 1002"
        :visible="visibleRoleSelect"
        v-show="visibleRoleSelect"
        @close="visibleRoleSelect = false"
        @getAward="getAward"
      ></AwardRoleSelect>
    </transition>
    <PopupWindow
      v-if="visibleTipPopup"
      style="z-index: 1002"
      type="tips"
      :languages="letter"
      :content="popupTip"
      textAlign="center"
      @onConfirm="visibleTipPopup = false"
      @onCancel="visibleTipPopup = false"
    ></PopupWindow>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AwardRoleSelect from '@components/officialTopup/activity/AwardRoleSelect';
import { clickButton, showPopup } from '@plugins/biPoint/_configWebstoreV3';
import {
  POPUP_TYPE,
  GET_TIME_AWARD,
  POPUP_LIMIT_TYPE
} from '@store/officialTopup/activity';
import { UPDATE_IS_LOGIN_POPUP } from '@store/officialTopup/login';
import globalConfig from '@utiles/officialStore/globalConfig';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
export default {
  name: 'WelcomePopup',
  props: {
    popupInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      welcomeVisible: false,
      visibleRoleSelect: false,
      visibleTipPopup: false,
      popupTip: ''
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      letter: state => state.letter,
      isLogin: state => state.login.isLogin
    }),
    showImage() {
      return this.popupInfo?.basic?.img;
    }
  },
  methods: {
    hideWelcomePopup() {
      this.welcomeVisible = false;
    },
    clickPopupHandle() {
      switch (this.popupInfo.basic.popupType) {
        // 跳转弹窗
        case POPUP_TYPE.REDIRECT:
          sdkOpenLink({
            link: getGlobalGetGotoLink({
              link: this.popupInfo?.basic?.redirectLink
            })
          });
          break;
        // 领奖弹窗
        case POPUP_TYPE.AWARD:
          if (!this.isLogin) {
            return this.$store.commit(UPDATE_IS_LOGIN_POPUP, true);
          }
          this.visibleRoleSelect = true;
          break;
      }
    },
    showTipPopup(content) {
      this.popupTip = content;
      this.visibleTipPopup = true;
    },
    async getAward(role) {
      const res = await this.$store.dispatch(GET_TIME_AWARD, {
        name: this.popupInfo.enname,
        ...role
      });
      if (res.code === 1) {
        this.showTipPopup(this.letter.limitedTimeActivityGetSucc);
        this.hideWelcomePopup();
        window.webstorev3DataLayer.push({
          eventName: 'gift',
          eventType: '',
          eventReason: this.popupInfo.enname,
          eventValue: ''
        });
      } else {
        this.showTipPopup(
          `[${res.code}]${this.letter.limitedTimeActivityGetFail}`
        );
      }
      this.visibleRoleSelect = false;
    }
  },
  created() {
    // 初始化，有图片再显示弹窗
    if (!this.popupInfo?.basic?.img) return;
    const key = `pay-welcomePopup-${this.popupInfo.enname}`;
    // 针对首次弹出类型弹窗，如果已经显示过，不再显示
    if (this.popupInfo.basic.limitType === POPUP_LIMIT_TYPE.FIRST_VISIT) {
      if (globalConfig.getLclStorageItem(key)) return;
      globalConfig.setLclStorageItem(key, true);
    }
    this.welcomeVisible = true;
  },
  components: {
    AwardRoleSelect
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';
.welcome {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    max-width: 660px;
    &-close {
      color: #ffffff;
      width: 40px;
      height: 40px;
      display: block;
      position: absolute;
      right: -40px;
      top: -40px;
      cursor: pointer;
    }
    &-img {
      max-width: 660px;
      object-fit: contain;
    }
  }
}
@media screen and (orientation: landscape) {
  .welcome {
    &-main {
      max-width: 1200px;
      &-img {
        max-width: 1200px;
        max-height: 90%;
      }
    }
  }
}
</style>
